import {formAnatomy as parts} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

// Default styles
// https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/theme%403.2.0/packages/components/theme/src/components/form-control.ts

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  container: {
    color: `text.secondary`,
    gap: `space-100`,
    width: `100%`,
    position: `relative`,
    fontSize: `sm`,
  },

  requiredIndicator: {
    color: `inherit`,
  },

  helperText: {
    mt: `space-100`,
    color: `inherit`,
  },
});

const FormControlTheme = defineMultiStyleConfig({
  baseStyle,
});

export default FormControlTheme;
